document.addEventListener( 'DOMContentLoaded', () => {
  let urlHasHighlightParam = false;

  const slideUp = ( el, duration = 750, callback = () => {} ) => {
    el.style.transition = `height ${duration}ms, opacity ${duration}ms`;
    el.style.overflow = 'hidden';
    el.style.height = el.offsetHeight + 'px';
    ( () => el.offsetHeight )();
    el.style.height = '0';
    el.style.opacity = '0';
    setTimeout( () => {
      el.style.display = 'none';
      el.style.removeProperty( 'height' );
      el.style.removeProperty( 'opacity' );
      el.style.removeProperty( 'transition' );
      el.style.removeProperty( 'overflow' );
      callback();
    }, duration );
  };

  const slideDown = ( el, duration = 750, callback = () => {} ) => {
    el.style.removeProperty( 'display' );
    let display = window.getComputedStyle( el ).display;
    if ( display === 'none' ) display = 'block';
    el.style.display = display;
    el.style.overflow = 'hidden';
    el.style.height = '0';
    el.style.opacity = '0';

    requestAnimationFrame( () => {
      const height = el.scrollHeight + 'px';
      el.style.transition = `height ${duration}ms ease, opacity ${duration}ms ease`;
      el.style.height = height;
      el.style.opacity = '1';
  
      setTimeout( () => {
        el.style.removeProperty( 'height' );
        el.style.removeProperty( 'opacity' );
        el.style.removeProperty( 'transition' );
        el.style.removeProperty( 'overflow' );
        callback();
      }, duration );
    } );
  };

  const fadeOutIn = ( oldSection, newContent, callback ) => {
    const container = document.querySelector( '.e-sgp__slide-down-popup' );
  
    const initialHeight = container.offsetHeight;
    container.style.minHeight = initialHeight + 'px';
  
    oldSection.style.transition = 'opacity 250ms';
    oldSection.style.opacity = '0';
    setTimeout( () => {
      oldSection.remove();
      container.insertAdjacentHTML( 'beforeend', newContent );
  
      const newSection = container.querySelector( 'section' );
      newSection.style.opacity = '0';
      newSection.style.transition = 'opacity 500ms';
      const newHeight = newSection.scrollHeight;
  
      container.style.transition = 'min-height 300ms ease-in-out';
      container.style.minHeight = newHeight + 'px';
  
      requestAnimationFrame( () => {
        newSection.style.opacity = '1';
        setTimeout( () => {
          container.style.removeProperty( 'min-height' );
          container.style.removeProperty( 'transition' );
          callback?.();
        }, 500 );
      } );
    }, 250 );
  };

  const highlightUrlParaChange = ( action, slug = null ) => {
    const newUrl = new URL( window.location.href );
    if ( action === 'add' ) {
      newUrl.searchParams.set( 'highlight', slug );
    } else {
      newUrl.searchParams.delete( 'highlight' );
    }
    window.history.replaceState( null, null, newUrl );
  };

  const postClose = ( posts ) => {
    document.querySelectorAll( '.e-sgp__slide-down-popup-close' ).forEach( btn => {
      btn.addEventListener( 'click', () => {
        posts.forEach( post => post.classList.remove( 'e-sgp--active' ) );
        const popup = document.querySelector( '.e-sgp__slide-down-popup' );
        if ( popup ) {
          slideUp( popup, 750, () => {
            popup.remove();
            highlightUrlParaChange( 'remove', null );
          } );
        }
      } );
    } );
  };

  const postSlideDown = ( appendEl, posts, appendPos ) => {
    const parent = posts[appendPos].parentElement;
    parent.insertAdjacentHTML( 'afterend', appendEl );
    postClose( posts );
    const popup = document.querySelector( `.e-sgp__slide-down-popup[data-append="${appendPos}"]` );
    if ( popup ) {
      slideDown( popup, 750, () => {
        const postTop = posts[appendPos].parentElement.getBoundingClientRect().top + window.scrollY;
        const headerHeight = document.querySelector( 'header' )?.offsetHeight || 0;
        window.scrollTo( {
          top: postTop - headerHeight - 20,
          behavior: 'smooth'
        } );
      } );
    }
  };

  const popupLoadByURL = () => {
    const urlParams = new URLSearchParams( window.location.search );
    const popupSlug = urlParams.get( 'highlight' );
    if ( popupSlug ) {
      const trigger = document.querySelector( 
        `[data-name="partners_list"] .e-sgp--list-item[data-post-slug="${popupSlug}"]` 
      );
      if ( trigger ) {
        trigger.click();
        urlHasHighlightParam = true;
      }
    }
  };

  const postOpen = ( posts ) => {
    if ( !posts.length ) return;
  
    const itemPerRow = getItemsPerRow();
    const postsCount = posts.length;
  
    posts.forEach( ( post, index ) => {
      post.addEventListener( 'click', () => handlePostClick( post, index, posts, postsCount, itemPerRow ) );
    } );
  };
  
  const getItemsPerRow = () => {
    const width = window.innerWidth;
    if ( width < 992 ) return 1;
    if ( width < 1200 ) return 2;
    return 3;
  };
  
  const getAppendPosition = ( index, postsCount, itemPerRow ) => {
    const isLastInRow = index % itemPerRow === itemPerRow - 1;
    const isLastPost = index + 1 === postsCount;
    const lastFullRowEnd = Math.floor( index / itemPerRow ) * itemPerRow + ( itemPerRow - 1 );
  
    if ( isLastPost || isLastInRow ) return index;
    if ( lastFullRowEnd < postsCount - 1 ) return lastFullRowEnd;
    return postsCount - 1;
  };
  
  const createPopupElement = ( appendPos, postContent ) => `
    <div class="e-sgp__slide-down-popup col-sm-12" data-append="${appendPos}">
      <span class="e-sgp__slide-down-popup-close"></span>
      ${postContent}
    </div>`;
  
  const handlePostClick = ( post, index, posts, postsCount, itemPerRow ) => {
    if ( post.classList.contains( 'e-sgp--active' ) || post.classList.contains( 'no-popup' ) ) return;
  
    posts.forEach( p => p.classList.remove( 'e-sgp--active' ) );
    post.classList.add( 'e-sgp--active' );
  
    const postId = post.dataset.postId;
    const postContentEl = document.querySelector( 
      `[data-name="partners_list"] .fancybox__content[data-post-id="${postId}"]` 
    );
    const postContent = postContentEl ? postContentEl.innerHTML : '';
    const appendPos = getAppendPosition( index, postsCount, itemPerRow );
    const appendEl = createPopupElement( appendPos, postContent );
    const postSlug = post.dataset.postSlug;
  
    highlightUrlParaChange( 'add', postSlug );
    urlHasHighlightParam = true;
  
    openSlideDown( appendEl, appendPos, postContent, posts );
  };
  
  const openSlideDown = ( appendEl, appendPos, postContent, posts ) => {
    const currentPopup = document.querySelector( '.e-sgp__slide-down-popup' );
    const insertNewPopup = () => postSlideDown( appendEl, posts, appendPos );
  
    if ( !currentPopup ) {
      insertNewPopup();
      return;
    }
  
    const currAppendPos = parseInt( currentPopup.dataset.append );
  
    if ( currAppendPos !== appendPos ) {
      slideUp( currentPopup, 750, () => currentPopup.remove() );
      insertNewPopup();
    } else {
      const section = currentPopup.querySelector( 'section' );
      currentPopup.style.minHeight = currentPopup.offsetHeight + 'px';
      fadeOutIn( section, postContent, () => {} );
    }
  };
  

  const initializePosts = () => {
    const posts = Array.from( document.querySelectorAll( '[data-name="partners_list"] .e-sgp--list-item' ) );
    postOpen( posts );
  };

  initializePosts();
  popupLoadByURL();

  document.addEventListener( 'facetwp-refresh facetwp-loaded', () => {
    if ( urlHasHighlightParam ) {
      window.history.pushState( 'Partner', 'Partner', window.location.href.split( '?' )[0] );
      urlHasHighlightParam = false;
    }
  } );

  window.addEventListener( 'load', () => {
    initializePosts();
    popupLoadByURL();
  } );
  document.addEventListener( 'facetwp-loaded', () => {
    initializePosts();
    popupLoadByURL();

  } );
} );
